﻿import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { Location } from '@angular/common';
import { AuthRejectShip } from 'src/app/Models/auth-reject-ship';

@Component({
    selector: 'auth-reject-add',
    templateUrl: './auth-reject-add.component.html',
    styleUrls: ['./auth-reject-add.component.scss']
})
/** auth-reject-add component*/
export class AuthRejectAddComponent implements OnInit{
  users: any[] = [];
  selectedUser: string = "";
  id: any;
  form: FormGroup;
  submitted: boolean;
  authReject: AuthRejectShip;
  submitButtonText: string = 'GENERAL.LABELS.CREATE';
  isEditing: boolean;
  initDate: Date;
  endDate: Date;
  status: boolean = false;
  hours: string[] = ["6:00", "12:00", "18:00", "00:00"]
  selectedInitHour: string = "";
  selectedEndHour: string = "";
  permissionTypes: string[] = ["GENERAL.ENUMS.PERMISSION_TYPE.REJECT_SHIP", "GENERAL.ENUMS.PERMISSION_TYPE.REACTIVATE_SHIP"];
  selectedPermissionType: string;

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService,
    private messageService: MessageService, private location: Location) {
    this.initDate = new Date();
    this.endDate = new Date();
    this.id = this.activatedRoute.snapshot.params['id'];
    this.getUsers();
    this.selectedInitHour = "00:00";
    this.selectedEndHour = "00:00";
  }

  ngOnInit(): void {

    if (this.id) {
      this.isEditing = true;
      this.submitButtonText = 'GENERAL.LABELS.EDIT';
      this.apiService.get('api/ship/getAuthReject/' + this.id).subscribe((data: any) => {
        this.authReject = data.data;
        this.selectedUser = this.authReject.username;
        this.initDate = this.authReject.initDate;
        this.endDate = this.authReject.endDate;
        this.status = this.authReject.status;
        this.selectedPermissionType = this.permissionTypes[this.authReject.permissionType ];
      });

    }
  }

  get controls() { return this.form.controls; }


      getUsers(){
        this.apiService.get('api/user/getUsersUsername').subscribe(response => {
            if(response.data){
                this.users = response.data;
            }
        });
    } 

  back() {
    this.location.back();
  }

  getHour(hour: string){
    switch(hour){
        case "00:00": return 0;
        case "6:00": return 6;
        case "12:00": return 12;
        case "18:00": return 18;
        default: return 0;
    }
  }

  onSubmit() {
    this.submitted = true;

    if (!this.selectedUser) {
        this.messageService.error("Error", "Debe seleccionar un usuario");
      return;
    }

    if(!this.selectedPermissionType){
      this.messageService.error("Error", "Debe seleccionar un tipo de permiso");
      return;
    }

    let model: AuthRejectShip = new AuthRejectShip();
    let temInitDate: Date = new Date(this.initDate);
    let temEndDate: Date = new Date(this.endDate);
    temInitDate.setHours(this.getHour(this.selectedInitHour), 0, 0, 0);
    temEndDate.setHours(this.getHour(this.selectedEndHour), 0, 0 ,0);
    model.username = this.selectedUser;
    model.initDate = temInitDate;
    model.endDate = temEndDate;
    model.status = this.status;
    model.permissionType = this.permissionTypes.indexOf(this.selectedPermissionType);

    if (this.isEditing) {
      model.id = this.id;
      this.apiService.put('api/ship/updateAuthReject', model).subscribe((response:any) => {
        if(response.data == 1){
          this.messageService.success("VEHICLES.MESSAGES.SUCCESS", "AUTHREJECT.MESSAGES.SUCCESS");
          this.location.back();
        }else{
          this.messageService.error("Error", 'VEHICLES.MESSAGES.VEHICLE_REGISTER');
        }
        
      }, error => {
        this.messageService.handleError(error);
      });
    }
    else {
      this.apiService.post('api/ship/saveAuthReject', model).subscribe((response: any) => {
        if(response.data == 0){
          this.messageService.error("Error", 'VEHICLES.MESSAGES.VEHICLE_REGISTER');
          
          
        }else{
          this.messageService.success("VEHICLES.MESSAGES.SUCCESS", "AUTHREJECT.MESSAGES.SUCCESS");
          this.location.back();
        }
      }, error => {
        this.messageService.handleError(error);
      });
    }
  }
}